import React from 'react';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {MenuItem, IconMenu, IconButton, Avatar} from 'material-ui';
import {grey400} from 'material-ui/styles/colors';
import gravatar from 'gravatar'
import {Link} from "react-router-dom";
import style from '../../../styles/styles';
import {ListItem} from 'material-ui/List';
import PropTypes from 'prop-types';
import withTranslation from "../../../hoc/withTranslation";
import {APPLICATION_PAGE} from "../../../constants/routes";

const Application = (props) => {
    const { app } = props;

    const iconButtonElement = (
        <IconButton
            touch={true}
            tooltipPosition="bottom-left"
        >
            <MoreVertIcon color={grey400} />
        </IconButton>
    );

    const rightIconMenu = (id) => (
        <IconMenu
            iconButtonElement={iconButtonElement}
            listStyle={style.list}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}} >
            <Link to={APPLICATION_PAGE.replace(':appId', id)} >
                <MenuItem>
                    {props.t('generic.detail')}
                </MenuItem>
            </Link>
        </IconMenu>
    );

    return (
        <ListItem
            leftAvatar={<Avatar src={gravatar.url(app.name)} size={40}/>}
            primaryText={app.name}
            secondaryText={app.id}
            rightIconButton={rightIconMenu(app.id)}
        />
    );
};

Application.propTypes = {
    app: PropTypes.object
};

export default withTranslation(Application);



// WEBPACK FOOTER //
// src/components/application/InlineApplication/InlineApplication.js